import { render, staticRenderFns } from "./OfficeLocationModal.vue?vue&type=template&id=124b21be&"
import script from "./OfficeLocationModal.vue?vue&type=script&lang=js&"
export * from "./OfficeLocationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports